import { GATE_CATALOG_ITEM_TYPES } from "../../../enums/gateCatalogItemTypes.enum";
import { Reference } from "../../shared/refs";

export interface MakeObject {
  id?: string;
  label: string;
  manufacturer?: Reference;
}

export class Make {
  id?: string;
  label: string;
  manufacturer?: Reference;
  public selected = false;
  public gateCatalogItemType: string;

  constructor(make: MakeObject) {
    this.id = make.id;
    this.label = make.label;
    this.manufacturer = make.manufacturer;
    this.gateCatalogItemType = GATE_CATALOG_ITEM_TYPES.MAKE;
  }

  public set properties(make: MakeObject) {
    this.label = make.label;
  }

  public get values() {
    const make: MakeObject = {
      label: this.label,
    };

    if (this.manufacturer) {
      make.manufacturer = { id: this.manufacturer.id };
    }

    return make;
  }
}
